const featuredTopics = [
  {
    id: 1,
    title: '暴走黑料 · 七月猛料合集',
    summary: '本月最震撼的暴走黑料系列整理，涉及多位顶流艺人与圈内大事件，信息量爆炸。从综艺翻车到片场实锤，从深夜爆料到账号异常，一篇带你全面回顾。',
    tag: '暴走黑料',
    tagColor: 'bg-primary-500/10 text-primary-400 border-primary-500/20',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20in%20warm%20amber%20and%20deep%20crimson%20tones%2C%20flowing%20organic%20shapes%20representing%20entertainment%20news%20and%20celebrity%20culture%2C%20mysterious%20dramatic%20atmosphere%20with%20soft%20glowing%20light%20beams%2C%20dark%20elegant%20background%20with%20sophisticated%20texture%2C%20editorial%20magazine%20cover%20style%2C%20cinematic%20quality%20rendering%20with%20high%20contrast%2C%20bold%20visual%20design%20for%20media%20content%20platform&width=800&height=500&seq=carousel-1-2026&orientation=landscape',
    count: '36条更新',
    heat: '98°',
  },
  {
    id: 2,
    title: '黑料社精选 · 当红艺人真相揭秘',
    summary: '黑料社独家整理多位当红艺人的台前幕后真实故事，从片酬争议到代言翻车，从业内评价到同行爆料，多条线索交叉验证。',
    tag: '黑料社',
    tagColor: 'bg-accent-500/10 text-accent-400 border-accent-500/20',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20spotlight%20illuminating%20abstract%20stage%20scene%2C%20golden%20and%20coral%20warm%20tones%20creating%20mysterious%20entertainment%20atmosphere%2C%20flowing%20fabric%20and%20light%20patterns%20suggesting%20behind%20the%20scenes%20revelations%2C%20dark%20sophisticated%20background%20with%20artistic%20texture%2C%20cinematic%20composition%20with%20deep%20shadows%20and%20warm%20highlights%2C%20editorial%20photography%20style%2C%20bold%20and%20intriguing%20visual%20for%20gossip%20media&width=800&height=500&seq=carousel-2-2026&orientation=landscape',
    count: '24条更新',
    heat: '95°',
  },
  {
    id: 3,
    title: '综艺争议 · 录制现场幕后直击',
    summary: '多个热门综艺节目录制现场频频曝出争议事件，从嘉宾冲突到导演组操作，从后期剪辑到剧本质疑，多角度呈现综艺圈真实生态。',
    tag: '综艺深扒',
    tagColor: 'bg-secondary-500/10 text-secondary-400 border-secondary-500/20',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20composition%20with%20intersecting%20warm%20light%20beams%20on%20dark%20background%2C%20golden%20amber%20and%20rose%20tones%20creating%20sense%20of%20revelation%20and%20discovery%2C%20mysterious%20atmospheric%20elements%20with%20floating%20particles%2C%20entertainment%20media%20themed%20visual%20with%20sophisticated%20editorial%20style%2C%20high%20contrast%20cinematic%20lighting%2C%20dramatic%20and%20bold%20composition%20suggesting%20breaking%20news%20and%20exclusive%20content&width=800&height=500&seq=carousel-3-2026&orientation=landscape',
    count: '18条更新',
    heat: '89°',
  },
  {
    id: 4,
    title: '网红圈风云 · 流量密码深度剖析',
    summary: '各大平台头部网红近期动态全景梳理，从账号涨跌到内容争议，从合作纠纷到人设崩塌，全面解读网红经济背后的流量逻辑。',
    tag: '网红观察',
    tagColor: 'bg-primary-500/10 text-primary-400 border-primary-500/20',
    image: 'https://readdy.ai/api/search-image?query=Warm%20dramatic%20abstract%20visual%20with%20golden%20and%20crimson%20flowing%20forms%2C%20mysterious%20entertainment%20atmosphere%20with%20theatrical%20spotlight%20effects%2C%20dark%20elegant%20background%20with%20subtle%20geometric%20patterns%2C%20sophisticated%20artistic%20rendering%20suggesting%20media%20coverage%20and%20exclusive%20stories%2C%20cinematic%20composition%20with%20rich%20warm%20tones%20against%20deep%20shadows%2C%20editorial%20quality%2C%20bold%20visual%20storytelling&width=800&height=500&seq=carousel-4-2026&orientation=landscape',
    count: '29条更新',
    heat: '87°',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
            热门专题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            精选暴走黑料与黑料社热门系列，一站式纵览
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {featuredTopics.map((topic) => (
            <article
              key={topic.id}
              className="group relative bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-500/30 transition-all duration-300"
            >
              <div className="flex flex-col sm:flex-row">
                <div className="sm:w-2/5 lg:w-2/5 relative overflow-hidden">
                  <div className="relative w-full aspect-[16/10] sm:aspect-[4/3]">
                    <img
                      src={topic.image}
                      alt={topic.title}
                      title={topic.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-r from-background-50/0 via-background-50/0 to-background-50/0 sm:bg-gradient-to-r sm:from-background-50/0 sm:via-background-50/0 sm:to-background-50"></div>
                  </div>
                </div>
                <div className="sm:w-3/5 lg:w-3/5 p-5 flex flex-col justify-between">
                  <div>
                    <div className="flex items-center gap-2 mb-3">
                      <span className={`inline-block px-2.5 py-0.5 rounded-full text-xs font-medium border ${topic.tagColor} whitespace-nowrap`}>
                        {topic.tag}
                      </span>
                      <span className="text-xs text-foreground-400">{topic.count}</span>
                    </div>
                    <h3 className="text-base md:text-lg font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors leading-snug">
                      {topic.title}
                    </h3>
                    <p className="mt-2 text-sm text-foreground-500 leading-relaxed line-clamp-3">
                      {topic.summary}
                    </p>
                  </div>
                  <div className="flex items-center justify-between mt-4 pt-3 border-t border-background-200/60">
                    <div className="flex items-center gap-1.5 text-accent-500">
                      <i className="ri-fire-fill text-sm"></i>
                      <span className="text-sm font-semibold">{topic.heat}</span>
                      <span className="text-xs text-foreground-400">热度</span>
                    </div>
                    <span className="text-xs text-primary-500 font-medium cursor-pointer hover:underline whitespace-nowrap">
                      查看详情 <i className="ri-arrow-right-line text-xs"></i>
                    </span>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}